<template>
  <v-container class="pb-12">
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="mt-12 px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          Nuevo Item de Inventario
        </div>
      </template>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  outlined
                  solo
                  :rules="[v => !!v || `${$t('stocks.name')} is required`]"
                  v-model="stockProfile.name"
                  :label="$t('stocks.name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  outlined
                  solo
                  v-model="stockProfile.sku"
                  :label="$t('stocks.sku')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="categories"
                  multiple
                  filled
                  outlined
                  :rules="[
                    v => v.length > 0 || `${$t('stocks.category')} is required`
                  ]"
                  solo
                  return-object
                  chips
                  deletable-chips
                  v-model="stockProfile.category"
                  :label="$t('stocks.category')"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="units"
                  chips
                  filled
                  outlined
                  :rules="[v => !!v || `${$t('stocks.unit')} is required`]"
                  solo
                  deletable-chips
                  v-model="stockProfile.unit"
                  :label="$t('stocks.unit')"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  filled
                  outlined
                  solo
                  :rules="[v => !!v || `${$t('stocks.unitValue')} is required`]"
                  step="1"
                  v-model.number="stockProfile.partialValue"
                  :label="$t('stocks.unitValue')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  step="1"
                  filled
                  outlined
                  :rules="[v => !!v || `${$t('stocks.quantity')} is required`]"
                  solo
                  v-model.number="stockProfile.quanty"
                  :label="$t('stocks.quantity')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-flex flex-column'"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          class="my-2"
          x-large
          width="200"
          @click="$router.back()"
        >
          {{ $t("stocks.cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success darken-1"
          class="my-2"
          x-large
          width="200"
          @click="save"
        >
          {{ $t("stocks.save") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return { valid: true, stockProfile: {} };
  },
  async created() {
    await this.$store.dispatch("stocks/bindCategories");
    await this.$store.dispatch("stocks/bindUnits");
  },
  computed: {
    ...mapState("stocks", ["stocksProfile", "categories", "units"])
  },
  methods: {
    async save() {
      const { $vs, $store, $router } = this;
      this.stockProfile.date = new Date();
      if (this.$refs.form.validate()) {
        const res = await this.$dialog.confirm({
          text: this.$t("dashboard.canYouConfirm"),
          title: this.$t("dashboard.checkFields")
        });

        if (res) {
          const loading = $vs.loading({
            background: "#730D0B",
            color: "rgb(255, 255, 255)",
            opacity: 1,
            type: "square"
          });
          try {
            await $store.dispatch("addDocument", {
              db: "stocks",
              data: this.stockProfile
            });
            this.$dialog.notify.success(
              "Your new stock has been created successfully",
              {
                position: "top-right",
                timeout: 5000
              }
            );
            $router.push({ name: "Stocks" });
          } catch (error) {
            console.error(error);
            this.$dialog.notify.error(error, {
              position: "top-right",
              timeout: 5000
            });
          } finally {
            loading.close();
          }
        }
      }
    }
  }
};
</script>

<style></style>
